import React from 'react';
export function LiveIndicator() {
  return <div className="flex items-center gap-2 bg-green-900/30 px-3 py-1 rounded-full" data-id="element-373">
      <div className="relative" data-id="element-374">
        <div className="absolute inset-0 bg-green-600 rounded-full animate-ping opacity-75" data-id="element-375"></div>
        <div className="relative w-3 h-3 bg-green-600 rounded-full" data-id="element-376"></div>
      </div>
      <span className="font-bold text-sm uppercase" data-id="element-377">Live</span>
    </div>;
}